<template>
  <div ref="printBody">
    <h2 class="py-3">Booking Summary</h2>

    <div class="flex flex-wrap py-3">
      <div class="w-full sm:w-6/12 lg:w-8/12">
        <p class="pb-2">
          Shipping Reference:
          {{ shipping.shippingReference ? shipping.shippingReference : "N/A" }}
        </p>
        <p>
          Service Type:
          <abbr class="font-semibold capitalize">{{ checkTerminalType }}</abbr>
        </p>
      </div>
      <div class="w-full sm:w-6/12 lg:w-4/12">
        <p class="pb-2">
          Return Shipping:
          {{ shipping.returnOrForwardingAddress ? "Yes" : "No" }}
        </p>
        <p>
          Shipping Option:
          <span>{{ costEngine ? costEngine.type : "N/A" }}</span>
          <span>{{
            shipping.shippingservice
              ? `${shipping.shippingservice.shippingMethod}`
              : ""
          }}</span>
        </p>
      </div>
    </div>

    <div class="flex flex-wrap border-t-2 border-gray-200 pb-4 mb-4">
      <div class="flex md:w-4/12 w-full  px-1 my-1">
        <div class="bg-primary-navy w-full flex text-white py-3 px-2">
          <span class="w-24 block mx-2"><img src="@/assets/images/ondemand/user-photo.svg" /></span>
          <p class="w-full">
            <span class="block w-full">SENDER</span>
            <span>{{
              shipping.shipperlocation
                ? shipping.shipperlocation.contactName
                : "N/A"
            }}</span>
            <span class="text-gray-400 w-full block">{{
              shipping.shipperlocation
                ? shipping.shipperlocation.address.name
                : "N/A"
            }}</span>
            <span class="text-gray-400 w-full flex pt-2 items-center">{{
              shipping.shipperlocation ? shipping.shipperlocation.email : "N/A"
              }}</span>
            <span class="text-gray-400 w-full block items-center">{{
              shipping.shipperlocation ? shipping.shipperlocation.mobile : "N/A"
              }}</span>
          </p>
        </div>
      </div>

      <div class="flex md:w-4/12 w-full px-1 my-1">
        <div class="bg-primary-navy  w-full flex items-start text-white py-3 px-2">
          <span class="mx-3"><img class="w-5" src="@/assets/images/icons/location.svg" /></span>
          <p class="w-full">
            <span>PICK-UP LOCATION</span>
            <span class="text-gray-400 pt-2 block w-full">{{
              shipping.shipperlocation
                ? shipping.shipperlocation.address.name
                : "N/A"
            }}</span>
          </p>
        </div>
      </div>

      <div class="flex md:w-4/12 w-full px-1 my-1">
        <div class="bg-primary-navy  w-full flex items-start text-white py-3 px-2">
          <span class="mx-3"><img class="w-5" src="@/assets/images/icons/location.svg" /></span>
          <p class="w-full">
            <span>RECEIVER</span>
            <span class="block pt-2 w-full">{{
              shipping.consigneelocation
                ? shipping.consigneelocation.contactName
                : "N/A"
            }}</span>
            <span class="text-gray-400 block pt-2 w-full">{{
              shipping.consigneelocation
                ? shipping.consigneelocation.address.name
                : "N/A"
            }}</span>
            <span class="text-gray-400 block pt-2 w-full">{{
              shipping.consigneelocation
                ? shipping.consigneelocation.email
                : "N/A"
            }}</span>
            <span class="text-gray-400 block pt-2 w-full">{{
              shipping.consigneelocation
                ? shipping.consigneelocation.mobile
                : "N/A"
            }}</span>
          </p>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap border-t-2 border-gray-200">
      <h2 class="py-3 px-3 w-full">Shipment Details</h2>
      <SummaryItem :label="shipping.shipperlocation
        ? shipping.shipperlocation.address.name
        : 'N/A'
        " title="ORIGIN">
        <img src="@/assets/images/booking-management/svgs/port-of-origin.svg" />
      </SummaryItem>

      <SummaryItem label="Package" title="SPECIFIED SHIPMENT">
        <img src="@/assets/images/booking-management/svgs/specified-shipment.svg" alt="" />
      </SummaryItem>
      <SummaryItem img="" :label="shipping.shippingMethod ? shipping.shippingMethod : 'N/A'" title="SHIPPING MODE">
        <img src="@/assets/images/booking-management/svgs/shipping-mode.svg" alt="" />
      </SummaryItem>
      <SummaryItem img="" :label="totalpackageType" title="PACKAGE TYPE">
        <img src="@/assets/images/booking-management/svgs/package-type.svg" alt="" />
      </SummaryItem>
      <SummaryItem img="" :label="shipping.consigneelocation
        ? shipping.consigneelocation.address.name
        : 'N/A'
        " title="DESTINATION">
        <img src="@/assets/images/booking-management/svgs/port-of-destination.svg" alt="" />
      </SummaryItem>
      <SummaryItem img="" label="Muleex" title="BOOKING CHANNEL">
        <img src="@/assets/images/booking-management/svgs/booking-channel.svg" alt="" />
      </SummaryItem>
      <SummaryItem img="" :label="shipping.shippingservice ? shipping.shippingservice.orgName : 'N/A'
        " title="SHIPPING OPTION">
        <img src="@/assets/images/booking-management/svgs/shipping-option.svg" alt="" />
      </SummaryItem>
      <SummaryItem img="" label="SC02099X" title="WAYBILL NO">
        <img src="@/assets/images/booking-management/svgs/channel-waybill.svg" alt="" />
      </SummaryItem>
      <SummaryItem img="" :label="totalpackageDiscription" title="PACKAGE DESCRIPTION">
        <img src="@/assets/images/booking-management/svgs/channel-waybill.svg" alt="" />
      </SummaryItem>
      <SummaryItem img="" :label="`${shipping.shipperlocation
        ? shipping.shipperlocation.address.name
        : 'N/A'
        } - 
          ${shipping.consigneelocation
          ? shipping.consigneelocation.address.name
          : 'N/A'
        }`
        " title="ROUTE">
        <img src="@/assets/images/booking-management/svgs/route.svg" alt="" />
      </SummaryItem>
      <SummaryItem img="" :label="shipping.distance ? shipping.distance + ' Km' : '0'" title="DISTANCE">
        <img src="@/assets/images/booking-management/svgs/distance.svg" alt="" />
      </SummaryItem>
    </div>


    <div class="flex flex-wrap border-t-2 border-gray-200">
      <h2 class="py-3 px-3 w-full pt-5">Package Details</h2>
      <div class="flex flex-wrap border-t-2 border-gray-200 mb-4" v-for="(_package, index) in shipping.packagees"
        :key="index">
        <h2 class="py-3 px-3 w-full pt-5">Package {{ index + 1 }}</h2>
        <SummaryItem img="" :label="_package.quantity || '0'" title="NUMBER OF PACKAGES">
          <img src="@/assets/images/booking-management/svgs/number-of-packages.svg" alt="" />
        </SummaryItem>
        <SummaryItem img="" :label="`${_package.estimatedWeight || '0'} (${_package.unitOfWeight})`" title="WEIGHT">
          <img src="@/assets/images/booking-management/svgs/channel-waybill.svg" alt="" />
        </SummaryItem>
        <SummaryItem img=""
          :label="_package.type == 'light pagkage' ? '' : `${_package.length}x${_package.width}x${_package.height} (${_package.unitOfDimension})`"
          title="DIMENSION (LxWxH)">
          <img src="@/assets/images/booking-management/svgs/dimension.svg" alt="" />
        </SummaryItem>
        <SummaryItem img="" :label="specialHandling(_package.specialHandling)" title="SPECIAL HANDLING">
          <img src="@/assets/images/booking-management/svgs/special-handling.svg" alt="" />
        </SummaryItem>
        <SummaryItem img="" :label="'₦ ' + amountFomatter(_package.itemValue)" title="DECLARED VALUE">
          <img src="@/assets/images/booking-management/svgs/declared-value.svg" alt="" />
        </SummaryItem>
        <SummaryItem img="" :label="_package.shipmentType" title="SHIPMENT TYPE">
          <img src="@/assets/images/booking-management/svgs/special-handling.svg" alt="" />
        </SummaryItem>
      </div>
    </div>




    <div class="flex flex-wrap border-t-2 border-gray-200">
      <h2 class="py-3 px-3 w-full pt-5">Payment Summary</h2>
      <SummaryItem img="" :label="paymentSummary" title="SERVICE">
        <img src="@/assets/images/booking-management/svgs/service.svg" alt="" />
      </SummaryItem>
      <SummaryItem img="" :label="costEngine.netPrice ? '₦ ' + amountFomatter(costEngine.netPrice) : '0'
        " title="NET SHIPPING COST">
        <img src="@/assets/images/booking-management/svgs/net-shipping-cost.svg" alt="" />
      </SummaryItem>
      <SummaryItem img="" :label="costEngine.handlingCharges
        ? '₦ ' + amountFomatter(costEngine.handlingCharges)
        : '₦ 0'
        " title="HANDLING CHARGES">
        <img src="@/assets/images/booking-management/svgs/booking-channel.svg" alt="" />
      </SummaryItem>
      <SummaryItem img="" :label="costEngine.insuranceFee
        ? '₦ ' + amountFomatter(costEngine.insuranceFee)
        : '0'
        " title="INSURANCE">
        <img src="@/assets/images/booking-management/svgs/insurance.svg" alt="" />
      </SummaryItem>
      <SummaryItem img="" :label="shipping.shippingservice
        ? '₦ ' +
        amountFomatter(
          shipping.shippingservice
            ? shipping.shippingservice.serviceCost
            : 0
        )
        : '₦ 0'
        " title="RETURN SHIPPING COST">
        <img src="@/assets/images/booking-management/svgs/booking-channel.svg" alt="" />
      </SummaryItem>
      <SummaryItem img="" label="₦ 0" title="STOP/DIVERSION COST">
        <img src="@/assets/images/booking-management/svgs/stop-diversion-cost.svg" alt="" />
      </SummaryItem>
      <SummaryItem img="" :label="costEngine
        ? '₦ ' + amountFomatter(costEngine.cost || costEngine.totalCost)
        : '0'
        " title="TOTAL">
        <img src="@/assets/images/booking-management/svgs/total.svg" alt="" />
      </SummaryItem>
      <SummaryItem img="" label="******" title="PROMO CODE">
        <img src="@/assets/images/booking-management/svgs/promo-code.svg" alt="" />
      </SummaryItem>
      <SummaryItem img="" label="₦ 0" title="DISCOUNT  TOTAL">
        <img src="@/assets/images/booking-management/svgs/number-of-packages.svg" alt="" />
      </SummaryItem>
      <SummaryItem img="" :label="costEngine.vat ? '₦ ' + amountFomatter(costEngine.vat) : '0'" title="Tax/VAT">
        <img src="@/assets/images/booking-management/svgs/tax-vat-charges.svg" alt="" />
      </SummaryItem>
      <SummaryItem img="" :label="costEngine
        ? '₦ ' + amountFomatter(costEngine.totalCost || costEngine.cost)
        : '0'
        " title="PAYMENT DUE">
        <img src="@/assets/images/booking-management/svgs/payment-due.svg" alt="" />
      </SummaryItem>
    </div>

    <div class="flex flex-wrap border-t-2 border-gray-200 px-3 justify-between py-4">
      <div>
        *This bill excludes duties and other government charges.
      </div>
      <div>
        <p class="text-right font-bold w-full pb-2">Select Payment Method</p>
        <div class="w-auto flex mt-1 gap-4 justify-start">
          <label for="dropAtTerminal" class="radio-label">
            <input class=" bg-primary-yellow text-secondary-yellow" name="senderShippingMethod" type="radio"
              id="dropAtTerminal" value="onDelivery" v-model="paymentMethod" />
            Pay on Delivery
            <span></span>
          </label>

          <label for="PickAtAddress" class="radio-label">
            <input type="radio" v-model="paymentMethod" value="PayNow" id="PickAtAddress" name="senderShippingMethod" />
            Pay Now
            <span></span>
          </label>
        </div>
      </div>
    </div>

    <div class="flex w-full items-center justify-between py-4 px-4">
      <button class="underline" @click="$emit('changeBookingTab', 4)">
        Back
      </button>
      <button class="py-1 px-2 rounded bg-primary-yellow">
        <el-dropdown class="h-full text-black" trigger="click">
          <button class="payment-assignqs h-full font-semibold  flex items-center ">
            <span class="mr-3 pr-2">Select</span>
            <el-icon class="el-icon--right"> <arrow-down-filled /></el-icon>
          </button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="isPayNow">
              <button @click="showPaymentModalFunc">Charge Card</button>
            </el-dropdown-item>

            <el-dropdown-item v-if="$store.state.authentication.env == 'development' && isPayNow">
              <button>Charge Wallet</button>
            </el-dropdown-item>

            <el-dropdown-item v-if="isPayDelivery">
              <button @click="closeCashModal = true">Cash Payment</button>
            </el-dropdown-item>
            <!-- <el-dropdown-item v-if="$store.state.authentication.env == 'development' && isPayNow">
              <button>Save Quote</button>
            </el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
      </button>
    </div>

    <PaymentModal @close-modal="showPaymentModal = false" :show-modal="showPaymentModal" @nextTab="nextTab"
      :total="costEngine ? bookingCost : '10'" />

    <CancleBooking @close-modal="closeCancleBooking = false" :showModal="closeCancleBooking" />

    <CashPaymentModal :costEngine="costEngine" @close-modal="closeCashModal = false" :showModal="closeCashModal" />
  </div>
</template>

<script>
import SummaryItem from "../SummaryItem.vue";
import PaymentModal from "../../modals/PaymentModal.vue";
import CancleBooking from "../../modals/CancleBooking.vue";
import CashPaymentModal from "../../modals/CashPaymentModal.vue";

export default {
  data() {
    return {
      shipping: {},
      closeCancleBooking: false,
      showPaymentModal: false,
      closeCashModal: false,
      paymentMethod: 'PayNow'
    };
  },
  mounted() {
    this.getBookingSummary();
    this.setpaymentype();
  },
  activated() {
    this.getBookingSummary();
  },
  computed: {
    isPayNow() {
      return this.paymentMethod === 'PayNow'
    },
    isPayDelivery() {
      return this.paymentMethod === 'onDelivery'
    },
    bookingCost() {
      const cost = this.costEngine.totalCost || this.costEngine.cost
      return Number(cost.toFixed(2))
    },
    checkTerminalType() {
      return this.shipping?.shippingMethod;
    },
    costEngine() {
      return (
        this.$store.getters.latestNewCostEngine ||
        this.$store.getters.latestNewCostEngine
      );
    },
    paymentSummary() {
      if (!this.shipping?.shippingservice) {
        return `${this.costEngine.vehicleType || ""}`
      }
      return `${this.shipping?.shippingservice?.orgName || ""}  ${this.shipping
        ?.shippingservice?.routeName || ""}`;
    },
    shippingId() {
      return this.$store.getters.latestNewInitialShipping?.id;
    },
    totalpackageWeight() {
      if (!this.shipping?.packagees.length) return "0";
      return this.shipping?.packagees
        .map((item) => item.estimatedWeight)
        .reduce((prev, next) => prev + next);
    },
    totalpackageValue() {
      if (!this.shipping?.packagees.length) return "0";
      return this.shipping?.packagees
        .map((item) => item.itemValue)
        .reduce((prev, next) => prev + next);
    },
    totalpackageDiscription() {
      if (!this.shipping?.packagees.length) return "";
      return this.shipping?.packagees
        .map((item) => item?.description)
        .reduce((prev, next) => prev + ", " + next);
    },
    totalpackageType() {
      if (!this.shipping?.packagees.length) return "";
      return (
        this.shipping?.packagees
          .map((item) => item?.packageType)
          .reduce((prev, next) => prev + " " + next) ?? "N/A"
      );
    },
    packageDimensions() {
      if (!this.shipping?.packagees.length) return "";
      return this.shipping?.packagees
        .map((item) => {
          if (!item?.length && !item?.width && !item?.height) return "N/A";
          return item?.length + "x" + item?.width + "x" + item?.height;
        })
        .reduce((prev, next) => prev + ", " + next);
    },
    totalshipmenttype() {
      if (!this.shipping?.packagees.length) return "";
      return this.shipping?.packagees
        .map((item) => item?.shipmentType)
        .reduce((prev, next) => prev + ", " + next);
    },
    totalpackageHandling() {
      if (!this.shipping?.packagees[0]?.specialHandling?.length) return "";
      else {
        return this.shipping?.packagees[0]?.specialHandling
          .map((item) => item)
          .reduce((prev, next) => prev + ", " + next);
      }
    },
  },
  watch: {
    paymentMethod(val) {
      let type = val == "onDelivery" ? 'Cash' : 'Card';
      this.$store.dispatch(
        "setBookingPaymentType",
        type
      );
    }
  },
  methods: {
    setpaymentype() {
      let type = this.packageType == "onDelivery" ? 'Cash' : 'Card';
      this.$store.dispatch(
        "setBookingPaymentType",
        type
      );
    },
    nextTab() {
      this.$emit("changeBookingTab", 7);
    },
    showPaymentModalFunc() {
      this.showPaymentModal = true;
    },
    specialHandling(val) {
      if (!val.length) return "";
      else {
        return val
          .map((item) => item)
          .reduce((prev, next) => prev + ", " + next);
      }
    },
    printElement() {
      // var domClone = elem.cloneNode(true);

      var $printSection = this.$refs.printBody;

      if (!$printSection) {
        $printSection = document.createElement("div");
        $printSection.id = "printSection";
        document.body.appendChild($printSection);
      }

      window.print();
    },
    async getBookingSummary() {
      try {
        const response = await this.$_getShipmentById(this.shippingId);
        this.shipping = response.data.data.shipping;
        this.$store.dispatch(
          "saveLatestNewShippingService",
          this.shipping?.shippingservice
        );
        this.$store.dispatch(
          "saveLatestNewTransactionId",
          this.shipping.transactionId
        );
      } catch (error) {
        this.handleError(error);
      }
    },
  },
  components: {
    SummaryItem,
    PaymentModal,
    CancleBooking,
    CashPaymentModal
  },
};
</script>

<style lang="scss" scoped>
.opaq-bg {
  background: rgba(252, 194, 16, 0.15);
  @apply border-primary-yellow max-w-[600px]
}
</style>
